(function () {
  class EuroguardSocialProofTabsController {
    constructor(root) {
      this.root = root;
      this.tabButtons = Array.from(root.querySelectorAll('[data-eg-social-proof-tab-button]'));
      this.reviewCards = Array.from(root.querySelectorAll('[data-eg-social-proof-review]'));
      this.videoCards = Array.from(root.querySelectorAll('[data-eg-social-proof-video-card]'));
      this.emptyState = root.querySelector('[data-eg-social-proof-empty]');
      this.videos = Array.from(root.querySelectorAll('[data-eg-social-proof-video]'));

      this.bindTabs();
      this.bindVideoControls();

      const activeButton = this.tabButtons.find((button) => button.classList.contains('is-active')) || this.tabButtons[0];
      if (activeButton) {
        this.setActiveTab(activeButton.dataset.egSocialProofTab);
      }
    }

    bindTabs() {
      this.tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.setActiveTab(button.dataset.egSocialProofTab);
        });
      });
    }

    setActiveTab(tab) {
      if (!tab) return;

      this.tabButtons.forEach((button) => {
        const isActive = button.dataset.egSocialProofTab === tab;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      let visibleReviewCount = 0;

      this.reviewCards.forEach((card) => {
        const isVisible = card.dataset.egSocialProofTab === tab;
        card.hidden = !isVisible;
        if (isVisible) visibleReviewCount += 1;
      });

      if (this.emptyState) {
        this.emptyState.hidden = visibleReviewCount > 0;
      }

      this.videoCards.forEach((card) => {
        card.classList.toggle('is-active', card.dataset.egSocialProofTab === tab);
      });
    }

    bindVideoControls() {
      this.root.querySelectorAll('[data-eg-social-proof-video-play]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          const video = this.getVideoFromControl(button);
          this.playVideo(video);
        });
      });

      this.root.querySelectorAll('[data-eg-social-proof-video-toggle]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          const video = this.getVideoFromControl(button);
          if (!(video instanceof HTMLVideoElement)) return;

          if (video.paused) {
            this.playVideo(video);
          } else {
            video.pause();
          }
        });
      });

      this.videos.forEach((video) => {
        const media = video.closest('.euroguard-social-proof-tabs__video-media');
        if (!(media instanceof HTMLElement)) return;

        const syncState = () => {
          const isPlaying = !video.paused && !video.ended;
          media.classList.toggle('is-playing', isPlaying);
          video.controls = isPlaying;
        };

        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', syncState);
        syncState();
      });
    }

    getVideoFromControl(control) {
      const card = control.closest('[data-eg-social-proof-video-card]');
      return card?.querySelector('[data-eg-social-proof-video]');
    }

    playVideo(video) {
      if (!(video instanceof HTMLVideoElement)) return;

      this.videos.forEach((item) => {
        if (item !== video) {
          item.pause();
          item.controls = false;
        }
      });

      video.controls = true;
      video.play().catch(() => {});
    }
  }

  const init = () => {
    document.querySelectorAll('[data-euroguard-social-proof-tabs]').forEach((root) => {
      if (root.dataset.egSocialProofTabsReady === 'true') return;
      root.dataset.egSocialProofTabsReady = 'true';
      new EuroguardSocialProofTabsController(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
